export default __webpack_public_path__ + "static/media/mandala_leg.73409bdc.jpg";